import AppError from '@App/error/AppError';

export default class RedirectError extends AppError {
    static CODE = 'redirect';

    getUrl() {
        return this.data.url;
    }
}
